import { z } from 'zod';

// emoji: null means the customer removed their reaction (Meta omits the emoji key entirely on removal;
// normalized to '' then null before reaching this schema — see manta's schemaInboundMessage).
export const schemaChatReactionReceivedPayload = z.object({
    emoji: z.string().min(1).nullable(),
    reactedToMetaMessageId: z.string().min(1),
    // ms
    sentAt: z.number().int().positive().optional(),
});

export type Schema_ChatReactionReceivedPayload = z.infer<typeof schemaChatReactionReceivedPayload>;
